import {
  HttpService,
  SSProfilesService,
  SSProfilesProvider,
} from "@sportal/api";

export const makeSSService = (
  http: HttpService,
  baseUrl: string
): SSProfilesService =>
  new SSProfilesService(new SSProfilesProvider(http, baseUrl));
